<template>
  <div class="attachment-email-container">
    <div class="attachment-email-content">
      <div class="attachment-email-header">
        <h2>邮件设置</h2>
        <p>配置邮件服务，用于注册验证、通知等</p>
      </div>
      
      <el-form :model="form" label-width="120px">
        <el-form-item label="邮件服务">
          <el-select v-model="form.emailService" placeholder="选择邮件服务">
            <el-option label="SMTP" value="smtp"></el-option>
            <el-option label="IMAP" value="imap"></el-option>
            <el-option label="POP3" value="pop3"></el-option>
            <el-option label="Exchange" value="exchange"></el-option>
            <el-option label="CardDAV" value="carddav"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="服务器地址">
          <el-input v-model="form.server" placeholder="请输入服务器地址"></el-input>
        </el-form-item>
        
        <el-form-item label="端口">
          <el-input-number v-model="form.port" :min="1" :max="65535" :step="1"></el-input-number>
        </el-form-item>
        
        <el-form-item label="用户名">
          <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        
        <el-form-item label="授权码">
          <el-input v-model="form.password" type="password" placeholder="请输入授权码"></el-input>
        </el-form-item>
        
        <el-form-item label="加密方式">
          <el-select v-model="form.encryption" placeholder="选择加密方式">
            <el-option label="SSL" value="ssl"></el-option>
            <el-option label="TLS" value="tls"></el-option>
            <el-option label="无" value="none"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="发件人邮箱">
          <el-input v-model="form.senderEmail" placeholder="请输入发件人邮箱"></el-input>
        </el-form-item>
        
        <el-form-item label="发件人名称">
          <el-input v-model="form.senderName" placeholder="请输入发件人名称"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="testEmail">测试邮件</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttachmentEmail',
  data() {
    return {
      form: {
        emailService: 'smtp',
        server: '',
        port: 465,
        username: '',
        password: '',
        encryption: 'ssl',
        senderEmail: '',
        senderName: ''
      }
    }
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const response = await this.$axios.get('/admin/email-setting')
        if (response.data && response.data.code === 200) {
          this.form = response.data.data
        }
      } catch (error) {
        console.error('加载邮件设置失败:', error)
      }
    },
    async saveSettings() {
      try {
        const response = await this.$axios.put('/admin/email-setting', this.form)
        if (response.data && response.data.code === 200) {
          this.$message.success('设置保存成功')
        } else {
          this.$message.error('保存失败')
        }
      } catch (error) {
        this.$message.error('保存失败: ' + (error.response ? error.response.data.detail : error.message))
      }
    },
    async testEmail() {
      if (!this.form.senderEmail) {
        this.$message.warning('请先保存邮件设置')
        return
      }
      this.$message.info('测试邮件发送中...')
      try {
        await this.$axios.post('/api/admin/test-email', {
          to_email: this.form.senderEmail,
          subject: '邮件设置测试',
          content: '这是一封测试邮件，如果您收到此邮件，说明邮件配置正确。'
        })
        this.$message.success('测试邮件发送成功')
      } catch (error) {
        this.$message.error('测试邮件发送失败: ' + (error.response ? error.response.data.detail : error.message))
      }
    },
    resetForm() {
      this.form = {
        emailService: 'smtp',
        server: '',
        port: 465,
        username: '',
        password: '',
        encryption: 'ssl',
        senderEmail: '',
        senderName: ''
      }
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.attachment-email-container {
  padding: 20px 0;
}

.attachment-email-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.attachment-email-header {
  margin-bottom: 30px;
}

.attachment-email-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.attachment-email-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}
</style>
